

















































































import { Component, Watch, Mixins } from 'vue-property-decorator';
import { ResHelper } from '@/helper/ResHelper';
import { LoadingState } from '@/entities/LoadingState';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { OrderInfo } from '@/entities/OrderInfo';
import { OrdersForUserModuleTypes } from '@/store/modules/orders-for-user';
import BaseMixin from '../../mixins/BaseMixin';
import _ from 'lodash/fp';
import parseISO from 'date-fns/fp/parseISO';
import OrderStateToolTip from '@/components/order-state-tooltip/OrderStateToolTip.vue';
import { OrderInfoItem } from '@/entities/OrderInfoItem';

@Component({
    components: {
        LoadingIndicator,
        OrderStateToolTip,
    },
})
export default class OrderList extends Mixins(BaseMixin) {
    private filter: string = '';
    private filterDebounced: () => void = _.debounce(500, () => {
        this.filterItems();
    });

    public mounted(): void {
        this.$store.dispatch(OrdersForUserModuleTypes.actions.loadOrders);
    }

    public get loadingFailed(): boolean {
        return this.$store.getters[OrdersForUserModuleTypes.getters.orderResultsLoadingState] === LoadingState.Failed;
    }

    public get isLoading(): boolean {
        return this.$store.getters[OrdersForUserModuleTypes.getters.orderResultsLoadingState] === LoadingState.Loading;
    }

    public get orderResults(): OrderInfo[] {
        return this.$store.getters[OrdersForUserModuleTypes.getters.orderResults];
    }

    private dateLocaleString(dateTimeISO: string | null): string {
        if (dateTimeISO == null) {
            return '';
        }

        const date = parseISO(dateTimeISO);
        return date.toLocaleDateString();
    }

    private orderedByText(item: OrderInfo): string {
        if (item.orderedByFirstName === '' && item.orderedByLastName === '') {
            return '';
        }

        return `<br/>(${item.orderedByFirstName} ${item.orderedByLastName})`;
    }

    private currencyTotalAmountString(item: OrderInfo): string {
        return `<span class="price__net">${ResHelper.getString(this.l10n.PRICE.NET)}</span> ${
            item.currencyHtmlSymbol
        } ${item.totalAmount}`;
    }

    private currencyAmountString(line: OrderInfoItem): string {
        return `<span class="price__net">${ResHelper.getString(this.l10n.PRICE.NET)}</span> ${
            line.currencyHtmlSymbol
        } ${line.amount}`;
    }

    private get columnHeaders(): any {
        return [
            {
                key: 'number',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_NUMBER),
            },
            {
                key: 'name',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_REFERENCE),
            },
            {
                key: 'date',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_DATE),
            },
            {
                key: 'status',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_STATUS),
            },
            {
                key: 'totalAmount',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_TOTAL_AMOUNT),
                class: 'text-right',
            },
            {
                key: 'items',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_ITEMS),
                class: 'text-right',
            },
            {
                key: 'show_details',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_SHOW_DETAILS),
            },
        ];
    }

    private get columnHeadersDetails(): any {
        return [
            {
                key: 'dmsPartNumber',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_DETAIL_PART_NUMBER),
            },
            {
                key: 'brandCode',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_DETAIL_MAKE),
            },
            {
                key: 'description',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_DETAIL_DESCRIPTION),
            },
            {
                key: 'quantity',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_DETAIL_QUANTITY),
                class: 'text-right',
            },
            {
                key: 'deliveredQuantity',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_DETAIL_DELIVERED_QUANTITY),
                class: 'text-right',
            },
            {
                key: 'amount',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_DETAIL_AMOUNT),
                class: 'text-right',
            },
            {
                key: 'infoText',
                label: ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_DETAIL_ADDITIONAL_INFO),
            },
        ];
    }

    @Watch('filter')
    private onFilterChange(): void {
        this.filterDebounced();
    }

    private filterItems(): void {
        this.$store.dispatch(OrdersForUserModuleTypes.actions.setFilter, this.filter);
    }

    private getDynamicDetailsButtonText(showDetails: boolean): string | undefined {
        return showDetails
            ? ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_HIDE_DETAILS)
            : ResHelper.getString(this.l10n.ORDERS_FOR_USER_TABLE.COL_SHOW_DETAILS);
    }
}
